import React, { useState } from "react";
import { REPLY_LENGTH, REPLY_STATUSES, STATUSES, defaultReplyStatus, isClosed, replyError } from "./feedbackRules";

/**
 * Staff reply: the new status (pills) and the message. onSend({ replyMsg, issueStatusId }) resolves true when saved,
 * which clears the message. A closed feedback opens again when replied with an open status.
 */
export default function FeedbackReplyBox({ feedback, busy, onSend }) {
  const [status, setStatus] = useState(() => defaultReplyStatus(feedback));
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const length = text.trim().length;
  const reopens = isClosed(feedback) && !isClosed({ statusId: status });

  const send = async () => {
    const problem = replyError(text, status);
    setError(problem);
    if (problem) return;
    if (await onSend({ replyMsg: text.trim(), issueStatusId: status })) setText("");
  };

  return (
    <section className="fbk-reply" aria-label="Staff reply">
      <h4>
        <i className="fas fa-reply" aria-hidden="true" /> Reply to the crew member
      </h4>
      <div className="fbk-reply__status" role="radiogroup" aria-label="New status">
        {REPLY_STATUSES.map((id) => (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={status === id}
            className={`fbk-pill is-${STATUSES[id].tone}${status === id ? " is-selected" : ""}`}
            disabled={busy}
            onClick={() => {
              setStatus(id);
              setError("");
            }}
          >
            <i className={STATUSES[id].icon} aria-hidden="true" /> {STATUSES[id].label}
          </button>
        ))}
      </div>
      {reopens && (
        <p className="fbk-reply__note">
          <i className="fas fa-info-circle" aria-hidden="true" /> This feedback is closed; this reply opens it again.
        </p>
      )}
      <textarea
        className="form-control"
        rows={4}
        aria-label="Reply"
        placeholder="e.g. Sorry for the delay. We have spoken to the vendor and it will not happen again."
        value={text}
        disabled={busy}
        onChange={(e) => {
          setText(e.target.value);
          setError("");
        }}
      />
      <div className="fbk-reply__foot">
        {error ? (
          <span className="fbk-reply__error" role="alert">
            <i className="fas fa-exclamation-circle" aria-hidden="true" /> {error}
          </span>
        ) : (
          <span className={`fbk-reply__count${length > REPLY_LENGTH ? " is-over" : ""}`}>
            {length} / {REPLY_LENGTH} · the crew member sees the reply and status in the crew app
          </span>
        )}
        <button type="button" className="btn btn-primary btn-sm" disabled={busy || !length} onClick={send}>
          <i className={`fas fa-${busy ? "spinner fa-spin" : "paper-plane"}`} aria-hidden="true" /> Send reply
        </button>
      </div>
    </section>
  );
}
